import { h, render } from 'preact';
import BuyingOptions from './BuyingOptions';
import { ProductVariant, Image } from '../types';

declare global {
    interface Window {
        __PRODUCT__: {
            variants: ProductVariant[];
            images: Image[];
            multiple: number;
            alias: string;
            name: string;
            isSpecialKnitwear: boolean;
        };
        __PRODUCTS__: [
            sku: {
            variants: ProductVariant[];
            images: Image[];
            multiple: number;
            alias: string;
            name: string;
            isSpecialKnitwear: boolean;
        }];
    }
}

export default function(container: HTMLDivElement) {
    const sku = container.dataset.productSku;
    if (sku) {
        var productVariants = window.__PRODUCTS__[sku].variants;
        var images = window.__PRODUCTS__[sku].images;
        var multiple = window.__PRODUCTS__[sku].multiple;
        var alias = window.__PRODUCTS__[sku].alias;
        var productName = window.__PRODUCTS__[sku].name;
        var isSpecialKnitwear = window.__PRODUCTS__[sku].isSpecialKnitwear;
    } else {
        var productVariants = window.__PRODUCT__.variants;
        var images = window.__PRODUCT__.images;
        var multiple = window.__PRODUCT__.multiple;
        var alias = window.__PRODUCT__.alias;
        var productName = window.__PRODUCT__.name;
        var isSpecialKnitwear = window.__PRODUCT__.isSpecialKnitwear;
    }

    container.innerHTML = '';
    render(
        <BuyingOptions
            table={container}
            productVariants={productVariants}
            images={images}
            multiple={multiple}
            alias={alias}
            productName={productName}
            isSpecialKnitwear={isSpecialKnitwear}
            isSchoolPage={sku !== undefined}
        />,
        container
    );
}
